import { useState, useCallback } from 'react';
import { getESMOverdueStocks } from '@/lib/api/esmOverdueStocksApi';
import { ESMOverdueStockItem } from '@/types/esmOverdueStocks';

export function useESMOverdueStocks() {
  const [allStocks, setAllStocks] = useState<ESMOverdueStockItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchESMOverdueStocks = useCallback(async (filters: Record<string, unknown>) => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await getESMOverdueStocks(filters);
      setAllStocks(data);
      return data;
    } catch (err) {
      const errorMessage = err instanceof Error 
        ? err.message 
        : 'Failed to load ESM overdue stocks. Please try again later.';
      setError(errorMessage);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    stocks: allStocks,
    loading,
    error,
    fetchESMOverdueStocks,
  };
}
